module.exports = __webpack_public_path__ + "img/bbac76a.jpg";